export const BILLING_METHODS = {
  TimeMaterial: 1,
  FixedPrice: 2,
} as const;

export type BillingMethodKey = keyof typeof BILLING_METHODS;
export type BillingMethodValue = (typeof BILLING_METHODS)[BillingMethodKey];
